<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader
        :loading="!flagNav"
        transition="scale-transition"
        max-height="64"
        type="table-heading"
      >
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{
            $t("_BlacklistChatUserManagement")
          }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>

      <v-card class="card2" style="margin-top: 1rem">
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" md="6">
              <v-card variant="outlined" class="pa-2 search-panel">
                <v-row no-gutters>
                  <v-col cols="9" class="pa-2">
                    <v-text-field
                      id="id-field-search-blacklist"
                      :label="$t('_userid')"
                      density="comfortable"
                      variant="outlined"
                      prepend-inner-icon="mdi-clipboard-text-search-outline"
                      hide-details
                      clearable
                      v-model="userID"
                      @keydown.enter="Search"
                      color="primary"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" class="pa-2 d-flex align-center justify-end">
                    <v-btn
                      id="button-search-rowtable-dataIntegration"
                      color="primary"
                      class="ml-2"
                      variant="elevated"
                      prepend-icon="mdi-magnify"
                      @click="Search"
                    >
                      {{  $t("search") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" md="6" class="d-flex flex-wrap justify-end gap-2">
              <v-btn
                id="button-add-blacklist"
                color="primary"
                class="control-btn create-btn"
                variant="elevated"
                size="large"
                prepend-icon="mdi-plus-circle"
                rounded="xl"
                @click="Adddialog = true"
              >
                <span class="btn-text">{{ $t("add") }}</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-data-table-server
          :items="userList"
          :items-per-page="options.itemsPerPage"
          :items-length="searchTotalTable"
          v-model:options="options"
          :headers="headers"
        >
          <!-- No Data Template -->
          <template v-slot:no-data>
            <div class="no-data-container">
              <div class="no-data-content">
                <!-- Icon -->
                <v-icon size="64" color="grey-lighten-2" class="no-data-icon">
                  mdi-account-cancel-outline
                </v-icon>
                
                <!-- Message -->
                <div class="no-data-text">
                  <h3 class="no-data-title">No Blacklisted Users Found</h3>
                  <p class="no-data-subtitle">There are currently no users in the blacklist. Add users to manage chat restrictions.</p>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td style="text-align: center">{{ item.number }}</td>
              <td>{{ item.userID }}</td>
              <td>{{ item.createDate }}</td>
              <td style="text-align: center">
                <!-- Delete Button -->
                <v-btn
                  id="button-delete-blacklist"
                  variant="text"
                  density="comfortable"
                  @click="DeleteUserBlacklist(item)"
                  class="action-btn delete-btn"
                  icon
                >
                  <v-icon size="18">mdi-delete-outline</v-icon>
                  <v-tooltip activator="parent" location="top">
                    Delete
                  </v-tooltip>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table-server>
      </v-card>
    </v-container>

    <!-- AddUserDialog -->
    <v-dialog
      v-model="Adddialog"
      max-width="650px"
      @click:outside="clearFields"
      transition="dialog-bottom-transition"
      class="modern-dialog"
    >
      <v-card class="dialog-card">
        <!-- Header -->
        <div class="dialog-header background-danger">
          <div class="header-main">
            <div class="header-icon-container">
              <div class="icon-background add-mode">
                <v-icon size="28" color="white">mdi-account-cancel</v-icon>
              </div>
            </div>
            <div class="header-text-content">
              <h2 class="dialog-title">Add to Blacklist</h2>
              <p class="dialog-subtitle">Select users to add to the blacklist</p>
            </div>
          </div>
        </div>

        <!-- Content -->
        <v-card-text class="dialog-content">
          <div class="input-section">
            <div class="input-label">
              <v-icon size="20" color="primary" class="mr-2">mdi-account-multiple-outline</v-icon>
              <span>Select Line Users</span>
              <span class="required-asterisk">*</span>
            </div>
            
            <v-autocomplete
              id="lineuser-autocomplete-blacklist"
              label="Search and select users"
              :items="LineUser"
              chips
              closable-chips
              item-title="userId"
              item-value="userId"
              multiple
              clearable
              v-model="LineUserID"
              variant="outlined"
              density="comfortable"
              hide-details="auto"
              class="modern-autocomplete"
              placeholder="Type to search users..."
              prepend-inner-icon="mdi-magnify"
              :rules="[v => v && v.length > 0 || 'Please select at least one user' ]"
            >
              <template v-slot:chip="{ props, item }">
                <v-chip
                  v-bind="props"
                  :text="item.raw.userId"
                  color="error"
                  variant="tonal"
                  size="small"
                  closable
                  class="user-chip"
                >
                  <template v-slot:prepend>
                    <v-icon size="16">mdi-account</v-icon>
                  </template>
                </v-chip>
              </template>
              
              <template v-slot:item="{ props, item, index }">
                <v-list-item
                  v-bind="props"
                  :id="'lineuser-option-' + index" 
                  :value="item.raw.name"
                  class="autocomplete-item"
                >
                  <template v-slot:prepend>
                    <v-avatar size="32" color="grey-lighten-3">
                      <v-icon size="18">mdi-account</v-icon>
                    </v-avatar>
                  </template>
                  
                  <v-list-item-subtitle v-if="item.raw.displayName" style="height: 20px;">
                    {{ item.raw.displayName }}
                  </v-list-item-subtitle>
                </v-list-item>
              </template>
              
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-title class="text-grey">
                    No users found
                  </v-list-item-title>
                </v-list-item>
              </template>
            </v-autocomplete>

            <!-- Info Message -->
            <div class="info-message">
              <v-icon size="16" color="info" class="mr-2">mdi-information-outline</v-icon>
              <span>Selected users will be restricted from chat functionality</span>
            </div>
          </div>
        </v-card-text>

        <!-- Actions -->
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          
          <v-btn
            variant="outlined"
            color="grey"
            class="dialog-action-btn cancel-btn"
            @click="closeadd"
            :disabled="dialog"
            prepend-icon="mdi-close"
          >
            {{ $t("cancel") || "Cancel" }}
          </v-btn>

          <v-btn
            id="button-save-popupadd-blacklist"
            color="error"
            variant="elevated"
            class="dialog-action-btn save-btn"
            @click="AddUserBlacklist"
            :loading="dialog"
            :disabled="!LineUserID || LineUserID.length === 0"
            prepend-icon="mdi-account-cancel"
          >
            Add to Blacklist
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <v-overlay v-model="dialog">
      <v-dialog v-model="dialog" persistent width="300">
        <v-card color="#1976D2" dark>
          <v-card-text class="white--text">
            Loading Please Wait...
            <v-progress-linear
              indeterminate
              color="#FAA91B"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay> -->
    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>

<script>
// import enurl from '@/api/environment';
import Cookies from "js-cookie";
// import store from '../store';

// import checkPermissionFour from "@/api/function.js";
import LogTrace from "@/api/function.js";
export default {
  name: "BlacklistChatUserManagement",
  inject: ["flagNav" ,"FontColorTitle","SubNavbarBackGround"],
  mixins: [LogTrace],
  data: () => ({
    // LineUserID: null,
    LineUserID: [],
    dialog: false,
    LineUser: [],
    Adddialog: false,
    isSearch: false,
    userID: "",
    totalTable: 0,
    itemsPerPage: 10,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    today: null,
    userList: [],
    headers: [],
    roleId: Cookies.get("roleId"),
    isFirst: true,
    searchTotalTable: 0,
    sortBy: [],
    sortDesc: [],
    loading: true,
  }),
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
    Adddialog(val) {
      if (!val) {
        this.clearFields();
      }
    },
  },
  mounted() {
    this.headers = [
      {
        title: this.$t("no"),
        align: "center",
        sortable: false,
      },
      {
        title: this.$t("_userid"),
        align: "center",
        sortable: true,
        value: "userID",
      },
      {
        title: this.$t("_date"),
        align: "center",
        sortable: true,
        value: "createDate",
      },
      {
        title: this.$t("delete"),
        align: "center",
        sortable: false,
      },
    ];
    this.GetDate();
  },
  computed: {},

  methods: {
    Search() {
      let self = this;
      self.dialog = true;
      self.isSearch = true;
      self.options.page = 1;
      self.GetSearch();
    },

    clearFields() {
      let self = this;
      self.resetForm();
    },

    resetForm() {
      let self = this;
      // self.LineUserID = null;
      self.LineUserID = [];
    },

    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },

    GetLineUserID() {
      let self = this;
      self.$call.GetLineUserID(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            const uniqueUsers = dataResponse.data.filter((user, index, arr) => 
              arr.findIndex(item => 
                item.userId === user.userId && 
                item.displayName === user.displayName
              ) === index
            );
            self.LineUser = uniqueUsers;
          } else {
            self.LineUser = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },

    async Get() {
      try {
        let self = this;
        self.dialog = true;
        
        let { page, itemsPerPage, sortBy } = self.options;
        let sortField = null;
        let sortOrder = null;

        if (sortBy && sortBy.length > 0) {
          sortField = sortBy[0].key;
          sortOrder = sortBy[0].order === 'desc';
        }
        let temp = {
          page: self.isSearch ? 1 : page,
          perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
          sortDesc: sortOrder,
          sortBy: sortField,
        };
        await self.$call.GetTableBlacklistChatUserManagement(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              if (dataResponse.data.total > 0) {
                self.searchTotalTable = dataResponse.data.total;
                self.userList = dataResponse.data.data;
                // self.totalTable = self.isFirst ? dataResponse.data.total : self.totalTable;
                self.totalTable = dataResponse.data.total;
              } else {
                self.userList = [];
                self.totalTable = 0;
                self.searchTotalTable = 0;
              }
            } else {
              self.userList = [];
              self.totalTable = 0;
              self.searchTotalTable = 0;
            }
            self.dialog = false;
            self.isSearch = false;
            self.isFirst = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.isSearch = false;
            console.error(errorResource);
          }
        );
        self.GetLineUserID();
      } catch (error) {
        this.LogTrace(error, "Get");
      }
    },

    GetSearch() {
      try {
        let self = this;
        self.dialog = true;
        self.loading = true;
        
        let { page, itemsPerPage, sortBy } = self.options;
        let sortField = null;
        let sortOrder = null;

        if (sortBy && sortBy.length > 0) {
          sortField = sortBy[0].key;
          sortOrder = sortBy[0].order === 'desc';
        }
        let temp = {
          page: self.isSearch ? 1 : page,
          perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
          userid: self.userID,
          sortDesc: sortOrder,
          sortBy: sortField,
        };
        self.$call.GetTableBlacklistChatUserManagement(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              if (dataResponse.data.total > 0) {
                self.searchTotalTable = dataResponse.data.total;
                self.userList = dataResponse.data.data;
                self.totalTable = self.isFirst
                  ? dataResponse.data.total
                  : self.totalTable;
              } else if (dataResponse.data.data.data == null) {
                self.userList = [];
                self.totalTable = 0;
                self.searchTotalTable = 0;
              }
            } else {
              self.userList = [];
              self.totalTable = 0;
              self.searchTotalTable = 0;
            }
            self.dialog = false;
            self.isSearch = false;
            self.isFirst = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.isSearch = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "Get");
      }
    },

    DeleteUserBlacklist(val) {
      let self = this;
      try {
        if (self.roleId != "0") {
          self.$swal.fire({
            icon: "warning",
            title: this.$t("notAuthoritySuperAdmin"),
            showConfirmButton: false,
            timer: 2000,
          });
          return;
        }
        self.$swal
          .fire({
            title: this.$t("confirmDeletion"),
            text: this.$t("confirmDeletionUser"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t("confirm"),
            cancelButtonText: this.$t("cancel"),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              let id = val.id;
              self.$call.DeleteBlacklistChatUser(
                id,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.totalTable = self.totalTable - 1;
                    self.Get();
                    self.$swal.fire({
                      icon: "success",
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                  } else if (dataResponse.status == 4) {
                    self.$swal.fire({
                      icon: "warning",
                      title: this.$t("oneSuperAdmin"),
                      showConfirmButton: false,
                      timer: 2000,
                    });
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        this.LogTrace(error, "DeleteUserBlacklist");
      }
    },

    closeadd() {
      let self = this;
      // self.LineUserID = null;
      self.LineUserID = [];
      self.Adddialog = false;
    },

    async AddUserBlacklist() {
      try {
        let self = this;
        self.dialog = true;
        if (self.LineUserID.length > 0) {
          await self.$call.SetBlacklistChatUser(
            self.LineUserID,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: "success",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.Adddialog = false;
                self.dialog = false;
                self.totalTable = self.totalTable + self.LineUserID.length;
                // self.LineUserID = null;
                self.LineUserID = [];
                await self.Get();
              } else {
                self.$swal.fire({
                  icon: "warning",
                  title: dataResponse.data.message,
                  showConfirmButton: false,
                  timer: 1800,
                });
              }
              self.LineUserID = [];
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              console.error(errorResource);
            }
          );
        } else {
          alert("Please fill all the fields!!!");
          self.Adddialog = true;
          self.dialog = false;
        }
      } catch (error) {
        this.LogTrace(error, "AddUserBlacklist");
      }
    },
  },
};
</script>
<style scoped>
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
}

.title {
  color: white;
}

.card {
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0 0 2rem 0;
  padding: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  /* transform: translateY(-1px); */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table-header th) {
  color: #495057 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  padding: 1rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}
.modern-autocomplete :deep(.v-field) {
  border-radius: 8px;
}

.info-icon {
  cursor: help;
  transition: all 0.2s ease;
}

.info-icon:hover {
  color: #1976d2 !important;
  transform: scale(1.1);
}
/* No Data Template */
.no-data-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  padding: 40px 20px;
}

.no-data-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 400px;
  gap: 24px;
}

.no-data-icon {
  opacity: 0.6;
  transition: opacity 0.3s ease;
}

.no-data-text {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.no-data-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #424242;
  margin: 0;
  letter-spacing: 0.025em;
}

.no-data-subtitle {
  font-size: 0.9rem;
  color: #757575;
  margin: 0;
  font-weight: 400;
  line-height: 1.4;
}

.no-data-btn {
  border-radius: 8px !important;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0.025em;
  min-width: 140px;
  height: 40px;
}

.no-data-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
}/* Dialog Styling */
.modern-dialog {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15) !important;
}

/* Header */
.dialog-header {
  background: linear-gradient(135deg, #d32f2f 0%, #b71c1c 100%);
  color: white;
  padding: 24px 32px !important;
  border-bottom: none;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
}

.header-icon {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-text {
  flex: 1;
}

.dialog-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
  color: white;
  line-height: 1.2;
}

.dialog-subtitle {
  font-size: 0.875rem;
  margin: 4px 0 0 0;
  opacity: 0.9;
  color: white;
  font-weight: 400;
}

/* Content */
.dialog-content {
  padding: 32px !important;
  background: #fafafa;
}

.input-section {
  background: white;
  padding: 24px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.input-label {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-weight: 600;
  color: #424242;
  font-size: 0.9rem;
}

.required-asterisk {
  color: #d32f2f;
  margin-left: 4px;
  font-weight: 700;
}

.modern-autocomplete :deep(.v-field) {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}

.modern-autocomplete :deep(.v-field:hover) {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.modern-autocomplete :deep(.v-field--focused) {
  box-shadow: 0 4px 16px rgba(211, 47, 47, 0.2);
}

.user-chip {
  margin: 2px 4px 2px 0 !important;
  font-weight: 500 !important;
}

.autocomplete-item {
  height: 70px !important;
}
.autocomplete-item:hover {
  background: rgba(211, 47, 47, 0.04) !important;
}

.info-message {
  display: flex;
  align-items: center;
  margin-top: 16px;
  padding: 12px 16px;
  background: rgba(33, 150, 243, 0.08);
  border-radius: 8px;
  border-left: 4px solid #2196f3;
  font-size: 0.875rem;
  color: #1565c0;
}

/* Actions */
.dialog-actions {
  padding: 24px 32px !important;
  background: white;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  gap: 12px;
}

.dialog-action-btn {
  border-radius: 10px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  min-width: 120px;
  height: 44px !important;
  font-size: 0.9rem !important;
}

.cancel-btn {
  color: #757575 !important;
  border-color: #e0e0e0 !important;
}

.cancel-btn:hover {
  background: rgba(117, 117, 117, 0.04) !important;
  border-color: #bdbdbd !important;
}

.save-btn {
  box-shadow: 0 4px 12px rgba(211, 47, 47, 0.3) !important;
}

.save-btn:hover {
  box-shadow: 0 6px 16px rgba(211, 47, 47, 0.4) !important;
  transform: translateY(-1px);
}

.save-btn:disabled {
  opacity: 0.6 !important;
  transform: none !important;
  box-shadow: none !important;
}

/* Responsive */
@media (max-width: 600px) {
  .dialog-header {
    padding: 20px 24px !important;
  }
  
  .dialog-content {
    padding: 24px !important;
  }
  
  .input-section {
    padding: 20px;
  }
  
  .dialog-actions {
    padding: 20px 24px !important;
    flex-direction: column-reverse;
  }
  
  .dialog-action-btn {
    width: 100%;
    margin: 4px 0 !important;
  }
}
</style>
